import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store'
import request from '@/utils/request';
import { MessageBox } from 'element-ui'

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'login',
		meta: {
			hideScrollTop: true
		},
		component: () => import("@/pages/login/login")
	},
	{
		path: '/knowledge-discovery',
		name: '知识发现',
		meta: {
			hideScrollTop: true
		},
		component: () => import("@/pages/knowledgeDiscovery/index")
	},

	/* 学生端 */
	//课程
	{
		path: '/student/course',
		name: 'studentCourse',
		meta: {
			location: 'course'

		},
		component: () => import("@/pages/student/course/course")
	},
	{
		path: '/student/course/courseDetails',
		name: 'studentCourseDetails',
		meta: {
			location: 'course'
		},
		component: () => import("@/pages/student/course/courseDetails")
	},
	{
		path: '/student/course/videoList',
		name: 'studentVideoList',
		meta: {
			location: 'course',
			hideScrollTop: true
		},
		component: () => import("@/pages/student/course/videoList")
	},

	//电子书
	{
		path: '/student/adjunct',
		name: 'studentAdjunct',
		meta: {
			location: 'adjunct'
		},
		component: () => import("@/pages/student/adjunct/adjunct")
	},

	{
		path: '/student/adjunct/adjunctDetails',
		name: 'studentAdjunctDetails',
		meta: {
			location: 'adjunct'
		},
		component: () => import("@/pages/student/adjunct/adjunctDetails")
	},

	//作业
	{
		path: '/student/homework',
		name: 'studentHomework',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/homework")
	},
	{
		path: '/student/homework/homeworkAnalysis',
		name: 'studentHomeworkAnalysis',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/homeworkAnalysis")
	},
	{
		path: '/student/homework/homeworkRecord',
		name: 'studentHomeworkRecord',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/homeworkRecord")
	},
	{
		path: '/student/homework/homeworkAnswer',
		name: 'studentHomeworkAnswer',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/homeworkAnswer")
	},
	{
		path: '/student/homework/homeworkAnalyzing',
		name: 'studentHomeworkAnalyzing',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/homeworkAnalyzing")
	},
	{
		path: '/student/homework/homeworkSelfRating',
		name: 'studentHomeworkSelfRating',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/homeworkSelfRating")
	},
	{
		path: '/student/homework/answerOverview',
		name: 'studentHomeworkAnswerOverview',
		meta: {
			location: 'homework'
		},
		component: () => import("@/pages/student/homework/answerOverview")
	},

	//考试
	{
		path: '/student/exam',
		name: 'studentExam',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/exam")
	},
	{
		path: '/student/exam/examAnswer',
		name: 'studentExamAnswer',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/examAnswer")
	},
	{
		path: '/student/exam/examAnalyzing',
		name: 'studentExamAnalyzing',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/examAnalyzing")
	},
	{
		path: '/student/exam/examSelfRating',
		name: 'studentExamSelfRating',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/examSelfRating")
	},
	{
		path: '/student/exam/examPaper',
		name: 'studentExamPaper',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/examPaper")
	},
	{
		path: '/student/exam/paperAnalysis',
		name: 'studentPaperAnalysis',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/paperAnalysis")
	},
	{
		path: '/student/exam/answerOverview',
		name: 'studentExamAnswerOverview',
		meta: {
			location: 'exam'
		},
		component: () => import("@/pages/student/exam/answerOverview")
	},

	//个人中心
	{
		path: '/student/personalCenter',
		name: 'studentPersonalCenter',
		component: () => import('@/pages/student/personalCenter/index'),
		children: [, {
			path: 'myNotes',
			name: 'studentPersonalMyNotes',
			component: () => import('@/pages/student/personalCenter/myNotes'),
		}, {
				path: 'course',
				name: 'studentPersonalCenterCourse',
				component: () => import('@/pages/student/personalCenter/course'),
			}, {
				path: 'mistake',
				name: 'studentPersonalMistake',
				component: () => import('@/pages/student/personalCenter/mistake'),
			}, {
				path: 'tracking',
				name: 'studentPersonalTracking',
				component: () => import('@/pages/student/personalCenter/tracking'),
			}, {
				path: 'courseFeedback',
				name: 'studentPersonalCourseFeedback',
				component: () => import('@/pages/student/personalCenter/courseFeedback'),
			}, {
				path: 'courseFeedbackDetails',
				name: 'studentPersonalCourseFeedbackDetails',
				component: () => import('@/pages/student/personalCenter/courseFeedbackDetails'),
			}, {
				path: 'settings',
				name: 'studentPersonalSettings',
				component: () => import('@/pages/student/personalCenter/settings'),
			}]
	},


	/* 教师端 */
	//课程
	{
		path: '/teacher/course',
		name: 'teacherCourse',
		meta: {
			location: 'course'
		},
		component: () => import("@/pages/teacher/course/course")
	},
	{
		path: '/teacher/course/courseDetails',
		name: 'teacherCourseDetails',
		meta: {
			location: 'course'
		},
		component: () => import("@/pages/teacher/course/courseDetails")
	},
	{
		path: '/teacher/course/videoList',
		name: 'teacherVideoList',
		meta: {
			location: 'course',
			hideScrollTop: true
		},
		component: () => import("@/pages/teacher/course/videoList")
	},
	{
		path: '/teacher/course/learningRecord',
		name: 'teacherLearningRecord',
		meta: {
			location: 'course',
			hideScrollTop: true
		},
		component: () => import("@/pages/teacher/course/learningRecord")
	},

	//电子书
	{
		path: '/teacher/adjunct',
		name: 'teacherAdjunct',
		meta: {
			location: 'adjunct'
		},
		component: () => import("@/pages/teacher/adjunct/adjunct")
	},

	{
		path: '/teacher/adjunct/adjunctDetails',
		name: 'teacherAdjunctDetails',
		meta: {
			location: 'adjunct'
		},
		component: () => import("@/pages/teacher/adjunct/adjunctDetails")
	},
	//电子书发布
	{
		path: '/teacher/adjunct/adjunctPublish',
		name: 'adjunct',
		meta: {
			location: 'adjunct'
		},
		component: () => import("@/pages/teacher/adjunct/adjunctPublish")
	},
	//试卷
	{
		path: '/teacher/testPaper',
		name: 'teacherTestPaper',
		meta: {
			location: 'testPaper'
		},
		component: () => import("@/pages/teacher/testPaper/testPaper")
	},

	{
		path: '/teacher/testPaper/testPaperList',
		name: 'teacherTestPaperListr',
		meta: {
			location: 'testPaper'
		},
		component: () => import("@/pages/teacher/testPaper/testPaperList")
	},

	//历年真题
	{
		path: '/teacher/testPaper/pastYearPaper',
		name: 'teacherPastYearPaper',
		meta: {
			location: 'testPaper'
		},
		component: () => import("@/pages/teacher/testPaper/pastYearPaper")
	},

	//历年真题详情
	{
		path: '/teacher/testPaper/pastYearDetail',
		name: 'teacherPastYearDetail',
		meta: {
			location: 'testPaper'
		},
		component: () => import("@/pages/teacher/testPaper/pastYearDetail")
	},
	//创建考试
	{
		path: '/teacher/testPaper/createExamOverView',
		name: 'createExamOverView',
		meta: {
			location: 'testPaper'
		},
		component: () => import("@/pages/teacher/testPaper/createExamOverView")
	},
	//试卷分析
	{
		path: '/teacher/testPaper/examAnalysis',
		name: 'examAnalysis',
		meta: {
			location: 'testPaper'
		},
		component: () => import("@/pages/teacher/testPaper/examAnalysis")
	},
	// 发布考试
	{
		path: '/teacher/testPaper/createExam',
		name: 'createExam',
		meta: {
			location: 'createExam'
		},
		component: () => import("@/pages/teacher/testPaper/createExam")
	},
	// 考试分析
	{
		path: '/teacher/personalCenter/paperAnalysis',
		name: 'teacherPersonalCenterPaperAnalysis',
		component: () => import('@/pages/teacher/personalCenter/paperAnalysis'),
	},
	//题库
	{
		path: '/teacher/questionBank',
		name: 'teacherQuestionBank',
		meta: {
			location: 'questionBank'
		},
		component: () => import("@/pages/teacher/questionBank/questionBank")
	},
	//题库预览
	{
		path: '/teacher/questionBank/publishPreview',
		name: 'teacherPublishPreview',
		meta: {
			location: 'questionBank'
		},
		component: () => import("@/pages/teacher/questionBank/publishPreview")
	},
	{
		path: '/teacher/questionBank/analysis',
		name: 'teacherPublishAnalysis',
		meta: {
			location: 'questionBank'
		},
		component: () => import("@/pages/teacher/questionBank/analysis")
	},

	//题库发布
	{
		path: '/teacher/questionBank/publishTestPaper',
		name: 'teacherPublishTestPaper',
		meta: {
			location: 'questionBank'
		},
		component: () => import("@/pages/teacher/questionBank/publishTestPaper")
	},

	//选苗
	{
		path: '/teacher/selectTalents',
		name: 'teacherSelectTalents',
		meta: {
			location: 'selectTalents',
			hideScrollTop: true
		},
		component: () => import("@/pages/teacher/selectTalents/selectTalents")
	},
	{
		path: '/teacher/selectTalents/evaluationList',
		name: 'teacherEvaluationList',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/evaluationList")
	},
	{
		path: '/teacher/selectTalents/testPaperAnalysis',
		name: 'teacherTestPaperAnalysis',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/testPaperAnalysis")
	},
	{
		path: '/teacher/selectTalents/viewProgress',
		name: 'teacherViewProgress',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/viewProgress")
	},
	{
		path: '/teacher/selectTalents/studentDetails',
		name: 'teacherStudentDetails',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/studentDetails")
	},
	{
		path: '/teacher/selectTalents/batchManage',
		name: 'teacherBatchManage',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/batchManage")
	},
	{
		path: '/teacher/selectTalents/testPaperDetails',
		name: 'teacherTestPaperDetails',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/testPaperDetails")
	},
	{
		path: '/teacher/selectTalents/studyScore',
		name: 'teacherStudyScore',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/studyScore")
	},
	{
		path: '/teacher/selectTalents/scoreDetails',
		name: 'teacherScoreDetails',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/scoreDetails")
	},
	{
		path: '/teacher/selectTalents/analysisReport',
		name: 'teacherAnalysisReport',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/analysisReport")
	},
	{
		path: '/teacher/selectTalents/analysisDetail',
		name: 'teacherAnalysisDetail',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/analysisDetail")
	},
	{
		path: '/teacher/selectTalents/viewExamPaper',
		name: 'teacherViewExamPaper',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/viewExamPaper")
	},
	{
		path: '/teacher/selectTalents/testPaperList',
		name: 'teacherSelectTalentsTestPaperList',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/testPaperList")
	},
	{
		path: '/teacher/selectTalents/pastYearDetail',
		name: 'teacherSelectTalentsPastYearDetail',
		meta: {
			location: 'selectTalents'
		},
		component: () => import("@/pages/teacher/selectTalents/pastYearDetail")
	},
	//看板
	{
		path: '/teacher/summary',
		name: 'teacherSummary',
		meta: {
			location: 'summary'
		},
		component: () => import("@/pages/teacher/summary/summary")
	},
	{
		path: '/teacher/summary/courseAnalysis',
		name: 'teacherSummaryAnalysis',
		meta: {
			location: 'summary'
		},
		component: () => import("@/pages/teacher/summary/courseAnalysis")
	},
	{
		path: '/teacher/summary/studentIndex',
		name: 'teacherSummaryStudentIndex',
		meta: {
			location: 'summary'
		},
		component: () => import("@/pages/teacher/summary/studentIndex")
	},
	{
		path: '/teacher/summary/studentDetail',
		name: 'teacherSummaryStudentDetail',
		meta: {
			location: 'summary'
		},
		component: () => import("@/pages/teacher/summary/studentDetail")
	},

	{
		path: '/teacher/summary/courseFeedback',
		name: 'teacherSummaryCourseFeedback',
		meta: {
			location: 'summary'
		},
		component: () => import("@/pages/teacher/summary/courseFeedback")
	},
	{
		path: '/teacher/summary/studentRecord',
		name: 'teacherSummaryStudentRecord',
		meta: {
			location: 'summary'
		},
		component: () => import("@/pages/teacher/summary/studentRecord")
	},
	//资源

	{
		path: '/teacher/resource',
		name: 'teacherResource',
		meta: {
			location: 'resource'
		},
		component: () => import("@/pages/teacher/resource/resource")
	},

	// 作业分析
	{
		path: '/teacher/homework/analysis',
		name: 'teacherPersonalCenterHomeworkAnalysis',
		meta: {
			location: 'homework'
		},
		component: () => import('@/pages/teacher/personalCenter/homeworkAnalysis'),
	},
	// 查看原卷
	{
		path: '/teacher/personalCenter/testPaperDetail',
		name: 'teacherPersonalCenterTestPaperDetail',
		meta: {
			location: 'homework'
		},
		component: () => import('@/pages/teacher/personalCenter/testPaperDetail'),
	},
	// 班级详情
	{
		path: '/teacher/personalCenter/classDetail',
		name: 'teacherPersonalCenterClassDetail',
		meta: {
			location: 'teacherPersonalCenter'
		},
		component: () => import('@/pages/teacher/personalCenter/classDetail'),
	},
	// 成绩详情
	{
		path: '/teacher/personalCenter/scoreDetail',
		name: 'teacherPersonalCenterScoreDetail',
		meta: {
			location: 'teacherPersonalCenter'
		},
		component: () => import('@/pages/teacher/personalCenter/scoreDetail'),
	},
	// 试卷详情
	{
		path: '/teacher/personalCenter/homeworkDetail',
		name: 'teacherPersonalCenterHomeworkDetail',
		meta: {
			location: 'teacherPersonalCenter'
		},
		component: () => import('@/pages/teacher/personalCenter/homeworkDetail'),
	},
	//个人中心
	{
		path: '/teacher/personalCenter',
		name: 'teacherPersonalCenter',
		component: () => import('@/pages/teacher/personalCenter/index'),
		children: [{
			path: 'adjunct',
			name: 'teacherPersonalCenterAdjunct',
			component: () => import('@/pages/teacher/personalCenter/adjunct'),
		}, {
			path: 'paper',
			name: 'teacherPersonalCenterPaper',
			component: () => import('@/pages/teacher/personalCenter/paper'),
		}, {
			path: 'settings',
			name: 'teacherPersonalCenterSettings',
			component: () => import('@/pages/teacher/personalCenter/settings'),
		}, {
			path: 'course',
			name: 'teacherPersonalCenterCourse',
			component: () => import('@/pages/teacher/personalCenter/course'),
		}, {
			path: 'homework',
			name: 'teacherPersonalCenterHomework',
			component: () => import('@/pages/teacher/personalCenter/homework'),
		}, {
			path: 'teacher',
			name: 'teacherPersonalCenterTeacher',
			component: () => import('@/pages/teacher/personalCenter/teacher'),
		}, {
			path: 'student',
			name: 'teacherPersonalCenterStudent',
			component: () => import('@/pages/teacher/personalCenter/student'),
		}, {
			path: 'class',
			name: 'teacherPersonalCenterClass',
			component: () => import('@/pages/teacher/personalCenter/class'),
		}, {
			path: 'score',
			name: 'teacherPersonalCenterScore',
			component: () => import('@/pages/teacher/personalCenter/score'),
		}, {
			path: 'courseFeedback',
			name: 'teacherPersonalCenterCourseFeedback',
			component: () => import('@/pages/teacher/personalCenter/courseFeedback'),
		}]
	},
	{
		path: '/teacher/personalCenter/courseFeedbackDetails',
		name: 'teacherPersonalCenterCourseFeedbackDetails',
		component: () => import('@/pages/teacher/personalCenter/courseFeedbackDetails'),
	},

	//AI
	{
		path: '/teacher/ai',
		name: 'teacherAi',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/index')
	},
	{
		path: '/teacher/ai/paperGenerator',
		name: 'teacherAiPaperGenerator',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/paperGenerator/index')
	},
	{
		path: '/teacher/ai/homeworkGrader',
		name: 'teacherAiHomeworkGrader',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/homeworkGrader/index')
	},
	{
		path: '/teacher/ai/socratesTutor',
		name: 'teacherAiSocratesTutor',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/socratesTutor/index')
	},
	{
		path: '/teacher/ai/photoSolver',
		name: 'teacherAiPhotoSolver',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/photoSolver/index')
	},
	{
		path: '/teacher/ai/examAnalysis',
		name: 'teacherAiExamAnalysis',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/examAnalysis/index')
	},
	{
		path: '/teacher/ai/pdfToWord',
		name: 'teacherAiPdfToWord',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/pdfToWord/index')
	},
	{
		path: '/teacher/ai/wordToPdf',
		name: 'teacherAiWordToPdf',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/wordToPdf/index')
	},
	{
		path: '/teacher/ai/splitPdf',
		name: 'teacherAiSplitPdf',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/splitPdf/index')
	},
	{
		path: '/teacher/ai/mergePdf',
		name: 'teacherAiMergePdf',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/mergePdf/index')
	},
	{
		path: '/teacher/ai/essayWordCorrection',
		name: 'teacherAiEssayWordCorrection',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/essayWordCorrection/index')
	},
	{
		path: '/teacher/ai/paperRestore',
		name: 'teacherAiPaperRestore',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/paperRestore/index')
	},
	{
		path: '/teacher/ai/mistake',
		name: 'teacherAiMistake',
		meta: {
			location: 'ai'
		},
		component: () => import('@/pages/teacher/ai/mistake')
	},
	{
		path: '*',
		name: 'notFound',
		component: () => import('@/pages/404')
	},
	{
		path: '/wechatCallback',
		name: 'wechatCallback',
		component: () => import('@/pages/wechatCallback'),
	},
	]
})

router.afterEach((to, from, next) => {

})

router.beforeEach(async (to, from, next) => {
	const whiteList = ['/', '/wechatCallback'];
	const tokenFromUrl = to.query.token
	const redirect = to.query.redirect

	if (tokenFromUrl) {
		localStorage.setItem('token', tokenFromUrl)
		// 🚨 history 模式必须清 query
		const query = { ...to.query }
		delete query.token
		delete query.redirect

		await request.get('userApi/getCurrUserInfo').then(async res => {
			if (res.succeeded) {
				store.commit('setStateObj', {
					paramName: 'userInfo',
					val: res.data
				})
				const role = res.data.role; // 1 学生，2 老师
				let message = '';
				if (role === 1) {
					message = '您正在模拟登录学生账号。请仅执行查看操作，勿进行添加、修改、删除、考试或作业提交等任何其他操作。';
				} else {
					message = '您正在模拟登录教师账号。请仅执行查看操作，勿进行添加、修改、删除或发布等任何其他操作。';
				}

				if (message) {
					await MessageBox.alert(message, '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						closeOnClickModal: false,
						closeOnPressEscape: false,
						showClose: false
					});
				}
			}
		})
		// 防止开放重定向
		if (redirect && redirect.startsWith('/')) {
			next({ path: redirect, replace: true })
		} else {
			next({ path: to.path, query, replace: true })
		}
		return
	}
	if (!whiteList.includes(to.path) && !localStorage.getItem('token')) {
		router.replace('/');
		return;
	}

	// 权限判断：学生只能进入 /student/ 路由，其他身份只能进入 /teacher/ 路由
	if (store.state.userInfo && store.state.userInfo.role) {
		const role = store.state.userInfo.role;
		if (!whiteList.includes(to.path)) {
			let isForbidden = false;
			if (role == 1 && to.path.startsWith('/teacher/')) {
				isForbidden = true;
			} else if (role != 1 && to.path.startsWith('/student/')) {
				isForbidden = true;
			}

			if (isForbidden) {
				Vue.prototype.$messageBox({
					title: '提示',
					message: '身份已更变，请重新登录',
					confirmText: '确认',
					showCancel: false,
					maskEvent: false,
					onConfirm: () => {
						localStorage.removeItem('token');
						window.location.href = '/';
					}
				})
				return;
			}
		}
	}

	let layoutState = {
		isShowHeader: true,
		isShowFooter: true,
		isSetPadding: true
	};

	if (to.path === '/' || to.path === '/wechatCallback') {
		layoutState = {
			isShowHeader: false,
			isShowFooter: false,
			isSetPadding: false
		};
	} else if (
		to.path === '/student/course/videoList' ||
		to.path === '/teacher/course/videoList' ||
		to.path === '/teacher/adjunct/adjunctDetails' ||
		to.path === '/student/adjunct/adjunctDetails'
	) {
		layoutState = {
			isShowHeader: true,
			isShowFooter: false,
			isSetPadding: false
		};
	} else if (
		to.path === '/teacher/testPaper/pastYearPaper' ||
		to.path === '/teacher/selectTalents'
	) {
		layoutState = {
			isShowHeader: true,
			isShowFooter: true,
			isSetPadding: false
		};
	}

	store.commit('setStateObj', {
		paramName: 'generalComponentState',
		val: layoutState
	});

	store.commit('setStateBasic', {
		paramName: 'routerLocation',
		val: to.meta.location
	})

	if (to.path === '/' && localStorage.getItem('token')) {
		const redirect = to.query.redirect || to.query.redirectUrl || to.query.url || to.query.target;
		const role = store.state.userInfo && store.state.userInfo.role;
		const defaultPath = role == 1 ? '/student/course' : '/teacher/course';
		let targetPath = defaultPath;
		if (redirect && typeof redirect === 'string') {
			let decoded = decodeURIComponent(redirect);
			if (decoded.startsWith('/')) {
				if (!decoded.includes('?')) {
					const otherQueries = { ...to.query };
					delete otherQueries.redirect;
					delete otherQueries.redirectUrl;
					delete otherQueries.url;
					delete otherQueries.target;
					delete otherQueries.token;
					const queryKeys = Object.keys(otherQueries);
					if (queryKeys.length > 0) {
						const queryString = queryKeys
							.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(otherQueries[key])}`)
							.join('&');
						decoded += `?${queryString}`;
					}
				}

				if (!(role == 1 && decoded.startsWith('/teacher/')) && !(role && role != 1 && decoded.startsWith('/student/'))) {
					targetPath = decoded;
				}
			}
		}
		router.replace(targetPath);
		return;
	}

	next();
});

window.__APP_ROUTE_COUNT__ = 0;
router.afterEach(() => {
	window.__APP_ROUTE_COUNT__ = (window.__APP_ROUTE_COUNT__ || 0) + 1;
});

export default router;